const whatsappMessage = 'Derneğinize websitesinden katıldım, herkese merhabalar.'

const umbrellaText = 'Ankara Ağrılılar Derneği, ilçe derneklerinin yerine geçmeyi değil; Ankara’da yaşayan tüm Ağrılıları, ilçe derneklerini ve hemşehri gruplarını ortak dayanışma çatısında görünür kılmayı hedefler.'

const DISTRICTS = [
  {
    slug: 'agri-merkez',
    name: 'Ağrı Merkez',
    communityName: 'Ankara Ağrılılar',
    headline: "Ankara'daki Ağrı merkezli hemşehrilerimiz aynı sofrada buluşuyor",
    image: '/img/car2.png',
    imageAlt: 'Ağrı Dağı manzarası',
    imageCredit: 'Dernek görsel arşivi',
    intro: `Ağrı Merkez; yüksek ova kültürü, kış manzaraları, güçlü aile bağları ve misafirperverliğiyle hafızalarda yer eden bir memleket merkezidir. Ankara Ağrılılar Derneği, Ağrı merkezden Ankara’ya gelen hemşehrilerimizin birbirini daha kolay bulması ve dayanışması için sıcak bir buluşma alanı oluşturur. ${umbrellaText}`,
    highlights: [
      'Ağrı Dağı manzarası ve Doğu Anadolu’nun geniş yayla ruhu',
      'Köklü hemşehri dayanışması, esnaf kültürü ve aile bağları',
      'Ankara’da eğitim, iş, sosyal destek ve kültürel buluşmalar'
    ],
    seoTerms: ['Ankara Ağrılılar', 'Ağrı merkezliler Ankara', 'Ağrı derneği Ankara', 'Ankara Ağrılılar WhatsApp grubu']
  },
  {
    slug: 'dogubayazit',
    name: 'Doğubayazıt',
    communityName: 'Ankara Doğubayazıtlılar',
    headline: "Ankara'daki Doğubayazıtlılar için kültür, tarih ve dayanışma sayfası",
    image: 'https://commons.wikimedia.org/wiki/Special:FilePath/Do%C4%9Fubayaz%C4%B1t%20Ishak%20Pasha%20Palace%20View%20to%20outside%205248%2018092012.jpg?width=1600',
    imageAlt: 'Doğubayazıt İshak Paşa Sarayı manzarası',
    imageCredit: 'Wikimedia Commons, Dosseman, CC BY-SA',
    intro: `Doğubayazıt; İshak Paşa Sarayı, Ağrı Dağı etekleri, Ahmed-i Hani kültürü ve tarihi geçiş yollarıyla Ağrı’nın en tanınan ilçelerindendir. Ankara’daki Doğubayazıtlı hemşehrilerimizin tanışması, gençlere rehberlik edilmesi ve kültürümüzün yaşatılması için bu sayfa bir çağrı niteliği taşır. ${umbrellaText}`,
    highlights: [
      'İshak Paşa Sarayı ve Doğubayazıt Kalesi çevresindeki tarihi miras',
      'Ağrı Dağı eteklerinde güçlü doğa, fotoğraf ve gezi potansiyeli',
      'Ahmed-i Hani geleneğiyle ilim, kültür ve manevi hafıza'
    ],
    seoTerms: ['Ankara Doğubayazıtlılar', 'Doğubayazıt derneği Ankara', 'Ankara Doğubayazıt hemşehri', 'Doğubayazıtlılar WhatsApp grubu Ankara']
  },
  {
    slug: 'patnos',
    name: 'Patnos',
    communityName: 'Ankara Patnoslular',
    headline: "Ankara'daki Patnoslular güçlü bir hemşehri ağı kuruyor",
    image: 'https://commons.wikimedia.org/wiki/Special:FilePath/S%C3%BCphan%20Da%C4%9F%C4%B1.jpg?width=1600',
    imageAlt: 'Patnos çevresinden Süphan Dağı manzarası',
    imageCredit: 'Wikimedia Commons, CC BY-SA',
    intro: `Patnos; Murat Nehri havzasına uzanan bereketli ovası, Urartu izleri, Süphan Dağı manzarası ve çalışkan insanıyla Ağrı’nın en büyük hemşehri damarlarından biridir. Ankara Patnoslular topluluğu, aileleri ve gençleri dernek çatısı altında buluşturmayı hedefler. ${umbrellaText}`,
    highlights: [
      'Süphan Dağı manzarası, ova kültürü ve doğal güzellikler',
      'Urartu dönemine uzanan tarihi hafıza ve eski yerleşim izleri',
      'Ankara’da Patnoslu aileler, öğrenciler, esnaflar ve çalışanlar için dayanışma'
    ],
    seoTerms: ['Ankara Patnoslular', 'Patnos derneği Ankara', 'Ankara Patnos hemşehri', 'Patnoslular WhatsApp grubu Ankara']
  },
  {
    slug: 'diyadin',
    name: 'Diyadin',
    communityName: 'Ankara Diyadinliler',
    headline: "Ankara'daki Diyadinliler şifalı suların ve yayla kültürünün izinde buluşuyor",
    image: 'https://commons.wikimedia.org/wiki/Special:FilePath/%29%29%29Diyadin%28%28%28%20-%20panoramio.jpg?width=1600',
    imageAlt: 'Diyadin ilçe manzarası',
    imageCredit: 'Wikimedia Commons, Panoramio arşivi',
    intro: `Diyadin; kaplıcaları, Murat Nehri çevresi, yüksek yayla havası ve doğal traverten görünümleriyle Ağrı’nın özel ilçelerindendir. Ankara’daki Diyadinli hemşehrilerimiz için bu sayfa, tanışma ve birlikte hareket etme davetidir. ${umbrellaText}`,
    highlights: [
      'Diyadin kaplıcaları ve doğal sıcak su kaynakları',
      'Murat Nehri çevresindeki vadiler, yaylalar ve doğa rotaları',
      'Ankara’da Diyadinli gençler ve aileler için güçlü iletişim ağı'
    ],
    seoTerms: ['Ankara Diyadinliler', 'Diyadin derneği Ankara', 'Ankara Diyadin hemşehri', 'Diyadinliler WhatsApp grubu Ankara']
  },
  {
    slug: 'eleskirt',
    name: 'Eleşkirt',
    communityName: 'Ankara Eleşkirtililer',
    headline: "Ankara'daki Eleşkirtililer yayla kültürü ve dayanışma için bir araya geliyor",
    image: 'https://commons.wikimedia.org/wiki/Special:FilePath/Z%C3%AAdka%20%28Ele%C5%9Fkirt%29%2C%20Agir%C3%AE.jpg?width=1600',
    imageAlt: 'Eleşkirt kırsal manzarası',
    imageCredit: 'Wikimedia Commons, CC BY-SA',
    intro: `Eleşkirt; yüksek rakımı, geniş yaylaları, kış kültürü ve Kösedağ çevresindeki doğal yapısıyla bilinir. Ankara Eleşkirtililer sayfası, memleket bağı güçlü olan hemşehrilerimizi dernek faaliyetlerine davet eder. ${umbrellaText}`,
    highlights: [
      'Yaylalar, dağ manzaraları ve Doğu Anadolu’nun serin iklimi',
      'Köy kültürü, tarım ve hayvancılık etrafında şekillenen üretken hayat',
      'Ankara’da Eleşkirtililer arasında eğitim, iş ve sosyal dayanışma'
    ],
    seoTerms: ['Ankara Eleşkirtililer', 'Eleşkirt derneği Ankara', 'Ankara Eleşkirt hemşehri', 'Eleşkirtililer WhatsApp grubu Ankara']
  },
  {
    slug: 'tutak',
    name: 'Tutak',
    communityName: 'Ankara Tutaklılar',
    headline: "Ankara'daki Tutaklılar komşuluk ve hemşehrilik bağıyla buluşuyor",
    image: '/img/car4.jpg',
    imageAlt: 'Ağrı kırsal doğa manzarası',
    imageCredit: 'Dernek görsel arşivi',
    intro: `Tutak; Murat Nehri çevresindeki geçiş yolları, köy kültürü, samimi komşuluk ilişkileri ve güçlü aile bağlarıyla tanınır. Ankara’daki Tutaklı hemşehrilerimiz dernek çatısı altında haberleşebilir, destek alabilir ve yeni projelerde birlikte yer alabilir. ${umbrellaText}`,
    highlights: [
      'Murat havzası, köyler ve doğal geçiş güzergahları',
      'Güçlü komşuluk, akrabalık ve hemşehri dayanışması',
      'Ankara’da Tutaklı aileler ve gençler için ortak iletişim alanı'
    ],
    seoTerms: ['Ankara Tutaklılar', 'Tutak derneği Ankara', 'Ankara Tutak hemşehri', 'Tutaklılar WhatsApp grubu Ankara']
  },
  {
    slug: 'taslicay',
    name: 'Taşlıçay',
    communityName: 'Ankara Taşlıçaylılar',
    headline: "Ankara'daki Taşlıçaylılar Ağrı Dağı eteklerinden Ankara'ya uzanan bağı yaşatıyor",
    image: '/img/hero-agri-dagi.jpg',
    imageAlt: 'Ağrı Dağı manzarası',
    imageCredit: 'Dernek görsel arşivi',
    intro: `Taşlıçay; Ağrı Dağı’na yakın konumu, Balık Gölü yolu, kırsal doğası ve sakin yaşamıyla memleket sevgisini diri tutan ilçelerimizdendir. Ankara Taşlıçaylılar topluluğu, bu bağı şehir hayatında da güçlendirmeyi amaçlar. ${umbrellaText}`,
    highlights: [
      'Balık Gölü çevresi, dağ manzaraları ve sakin doğa rotaları',
      'Köy kültürü, aile dayanışması ve memleketle güçlü bağ',
      'Ankara’da Taşlıçaylı hemşehriler için tanışma ve destek ağı'
    ],
    seoTerms: ['Ankara Taşlıçaylılar', 'Taşlıçay derneği Ankara', 'Ankara Taşlıçay hemşehri', 'Taşlıçaylılar WhatsApp grubu Ankara']
  },
  {
    slug: 'hamur',
    name: 'Hamur',
    communityName: 'Ankara Hamurlular',
    headline: "Ankara'daki Hamurlular sıcak hemşehri ortamında bir araya geliyor",
    image: '/img/car1.jpg',
    imageAlt: 'Ağrı doğa ve sosyal yaşam manzarası',
    imageCredit: 'Dernek görsel arşivi',
    intro: `Hamur; Ağrı merkeze yakınlığı, köyleri, yayla kültürü ve samimi insan ilişkileriyle öne çıkar. Ankara Hamurlular sayfası, hemşehrilerimizin birbirinden haberdar olması, dernek etkinliklerine katılması ve gençlere yol açması için hazırlandı. ${umbrellaText}`,
    highlights: [
      'Merkeze yakın konum, köyler ve yayla kültürü',
      'Samimi aile bağları, misafirperverlik ve ortak memleket hafızası',
      'Ankara’da Hamurlular için sosyal destek, tanışma ve etkinlik duyuruları'
    ],
    seoTerms: ['Ankara Hamurlular', 'Hamur derneği Ankara', 'Ankara Hamur hemşehri', 'Hamurlular WhatsApp grubu Ankara']
  }
]

export const districtWhatsappUrl = (districtName) => {
  const message = `${whatsappMessage} ${districtName} hemşehri grubuna katılmak istiyorum.`
  return `https://wa.me/905079217404?text=${encodeURIComponent(message)}`
}

export default DISTRICTS
